import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';

import {
  DASHBOARD_PATH,
  APPS_PATH,
  CREATE_APP_PATH,
  RESOURCES_PATHS,
  CREATE_MAGAZINE_PATHS
} from '../../utils/constants';

class SidebarContent extends PureComponent {
  render() {
    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          <SidebarLink
            title="Dashboard"
            icon="dashboard"
            route={DASHBOARD_PATH}
          />
          {/* <SidebarCategory title='Layout' icon='layers'>
            <li className='sidebar__link' onClick={this.changeToLight}>
              <p className='sidebar__link-title'>Light Theme</p>
            </li>
            <li className='sidebar__link' onClick={this.changeToDark}>
              <p className='sidebar__link-title'>Dark Theme</p>
            </li>
          </SidebarCategory> */}
          <li>
            <ul className="sidebar__block-submenu">
              <SidebarCategory
                title="Apps"
                icon="apps"
                className="with-icon-submenu"
                route={APPS_PATH}
              >
                <SidebarLink
                  title="Add a new app"
                  icon="add-app"
                  route={CREATE_APP_PATH}
                />
                <SidebarLink
                  title="Application list"
                  icon="app-list"
                  route={APPS_PATH}
                />
              </SidebarCategory>
            </ul>
          </li>
          <li>
            <ul className="sidebar__block-submenu">
              <SidebarCategory
                title="Resources"
                icon="resources"
                route={RESOURCES_PATHS.common}
              >
                <SidebarLink title="Magazine API" route={RESOURCES_PATHS.api} />
                <SidebarLink title="Magazine SDK" route={RESOURCES_PATHS.sdk} />
              </SidebarCategory>
            </ul>
          </li>
          <li>
            <ul className="sidebar__block-submenu">
              <SidebarCategory
                title="Create"
                icon="create"
                className="with-icon-submenu"
                route={CREATE_MAGAZINE_PATHS.common}
              >
                <SidebarLink
                  title="Instant magazine"
                  icon="instant-magazine"
                  route={CREATE_MAGAZINE_PATHS.instant}
                />
                <SidebarLink
                  title="Editor's pick"
                  icon="editors-pick"
                  route={CREATE_MAGAZINE_PATHS.picked}
                />
              </SidebarCategory>
            </ul>
          </li>
        </ul>
      </div>
    );
  }
}

export default connect()(SidebarContent);



// WEBPACK FOOTER //
// ./src/components/sidebar/SidebarContent.js